import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { type RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable()
export class TitleStrategyService extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly siteName = 'Match15';

  override updateTitle(routerState: RouterStateSnapshot): void {
    const title = this.buildTitle(routerState);

    if (title) {
      this.title.setTitle(`${title} • ${this.siteName}`);
    } else {
      this.title.setTitle(this.siteName);
    }
  }
}
